import type { TTrajectory } from '../../types/trajectory';
import { FactTrajectoryEntity, FactTrajectoryPointEntity } from '../entities';

import { mapApiStationToFactPoint, omitTrajectoryStations } from './map-api-trajectory';

export function resolveActiveFlag(
  raw: Pick<TTrajectory, 'active' | 'definitive' | 'activeStatus'>,
): boolean | undefined {
  if (typeof raw.active === 'boolean') {
    return raw.active;
  }

  // Catalog/infoOnly payloads often send activeStatus without a boolean `active`.
  // Prefer it over `definitive` — definitive is a different flag and was picking the wrong item.
  if (raw.activeStatus !== undefined) {
    return raw.activeStatus === 'ACTIVE';
  }

  if (typeof raw.definitive === 'boolean') {
    return raw.definitive;
  }

  return undefined;
}

export function mapFactTrajectory(raw: TTrajectory): FactTrajectoryEntity {
  const points = (raw.trajectoryStations ?? []).map(
    (station) => new FactTrajectoryPointEntity(mapApiStationToFactPoint(station)),
  );

  const data = omitTrajectoryStations(raw);
  const active = resolveActiveFlag(raw);

  return new FactTrajectoryEntity(
    {
      ...data,
      ...(active !== undefined ? { active } : {}),
    },
    points,
  );
}

export function mapEntityToTrajectoryDto(entity: FactTrajectoryEntity): TTrajectory {
  return {
    ...entity.data,
    active: Boolean(entity.data.active ?? entity.data.definitive),
    trajectoryStations: [],
  };
}
